<template>
  <b-form-group
    label="Proje"
    label-for="id_projects"
  >
    <validation-provider
      #default="{ errors }"
      name="Proje"
      rules="required"
    >
      <v-select
        id="id_projects"
        v-model="dataItem.id_projects"
        label="title"
        :options="projects"
        :reduce="project => project.id"
        placeholder="Seçiniz"
        :clearable="false"
      />
      <small class="text-danger">{{ errors[0] }}</small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup,
} from 'bootstrap-vue'
// eslint-disable-next-line no-unused-vars
import { required } from '@validations'
import vSelect from 'vue-select'

export default {
  name: 'ParamProject',
  components: {
    BFormGroup,
    vSelect,
    ValidationProvider,
  },
  data() {
    return {
      locale: 'tr',

    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['params/dataItem']
    },
    projects() {
      return this.$store.getters['projects/dataList']
    },
  },
  created() {
    localize(this.locale)
    this.getProjects()
  },
  methods: {
    getProjects() {
      this.$store.dispatch('projects/getDataList', {
        select: [
          'projects.id AS id',
          'projects.title AS title',
        ],
        where: {
          'projects.status': 1,
        },
      })
    },
  },
}
</script>

<style scoped></style>
